// Instagram にログインして、トークンを取得する https://instagram.com/developer/clients/manage
var token = '6007512661.885ef92.69f172efbd4a446cb94dbd4593e3bce3'; // 上記URLで取得したトークンコード
var numPhotos = 4; // 取得したい写真の枚数
var $instagramItems = $('.instagram__item');

if ($instagramItems.length > 0) {
  $.getJSON('https://api.instagram.com/v1/users/self/media/recent?access_token=' + token)
    .done(function (json) {
      json.data.forEach(function (item, index) {
        var caption = item.caption.text;
        var linkPattern = /https?:\/\/?www\.?(himeji-mitai.com)((.+)?(\.[a-z]*|\/))/g;
        var shopPattern = /\u300E(.+)\u300F/g; // 『』の中にある文字を取得する
        var shopName;
        var url;

        // インスタ投稿メッセージ文に入っているURLをlinkPatternルールによって取得
        if (caption.match(linkPattern)) {
          url = linkPattern.exec(caption)[2];
        } else {
          url = item.link;
        }

        // インスタ投稿メッセージ文に入っている店舗名をshopPatternによって取得
        if (caption.match(shopPattern)) {
          shopName = shopPattern.exec(caption)[1];
        } else if (item.users_in_photo[0]) {
          // shopPatternのルールがヒットしない場合は
          // インスタ写真に指定されたインスタアカウントを取得
          shopName = item.users_in_photo[0].user.full_name;
        } else {
          // どっちも無い場合はデフォルト文章を設定
          shopName = '今日のインスタ';
        }

        // HTMLにすでに入っている<a>要素のリンクを取得したリンクに設定
        var $imageLink = $($instagramItems[index])
          .find('a')
          .attr('href', url);

        // インスタから引っ張った画像のリンク先を画像要素として設定
        var $image = $('<img/>')
          .attr('class', 'lazyload')
          .attr('data-src', item.images.low_resolution.url)
          .attr('alt', shopName);

        // <a>要素の中にインスタから引っ張った画像を注入
        $image.appendTo($imageLink);

        // 取得した店舗名をHTML側に入れる
        $($instagramItems[index])
          .find('.instagram__name')
          .attr('href', url)
          .html(shopName);
      });
    })
    .fail(function (xhr, status, error) {
      console.warn('インスタ', xhr, status, error);
    });
} // end if .home
